import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./auth/context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import { LoadingProvider } from "./context/LoadingContext";
import LanguageSwitcher from "./components/LanguageSwitcher";
import "./App.css";

function App() {
  return (
    <LoadingProvider>
      <Router>
        <AuthProvider>
          <LanguageSwitcher />
          <AppRoutes />
        </AuthProvider>
      </Router>
    </LoadingProvider>
  );
}

export default App;